import axios from "axios";

export const tradeinHttp = axios.create({
  baseURL: process.env.REACT_APP_API_TRADE_IN_URL,
});
